import {SET_LANGUAGE} from "./actionTypes";

const initialState = {
    currentLanguage: localStorage.getItem("currentLanguage") || "English",
};

export const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LANGUAGE:
            return {
                ...state,
                currentLanguage: action.payload,
            };
        default:
            return state;
    }
};